import CONSTANTS from '../../constants';

export function trainers(state = null, action) {
    switch (action.type) {
        case CONSTANTS.ACTIONS.USER.GET.TRAINERS:
            return action.trainers;
        default:
            return state
    }
}